import { ApplicationState } from 'app/types-store';
import { retry } from 'app/infrastructure/js/retry';

/**
 * Wraps an action creator and delays it's execution until any pending changes has been saved.
 * This can be used to avoid race conditions due to paralell api requests, each using different etags.
 * A retry function allows the waiting process to be async awaitable.
 */
export const whenIdle = (actionCreator: any) => {
  const runWhenIdle = async (fn: any, dispatch: any, getState: () => ApplicationState, ...args: any[]) => {
    const { editing } = getState().caseArea;
    if (editing && (editing.saving || editing.hasChanges)) {
      // return a wait-promise instead of running the actionCreator
      return retry(() => runWhenIdle(actionCreator, dispatch, getState), 500, 500);
    }
    // Run the actionCreator
    return await fn(dispatch, getState, ...args);
  };

  // Wraps the actionCreator
  return async (dispatch: any, getState: any) => runWhenIdle(actionCreator, dispatch, getState);
};
